import LeadContractModal from './LeadContractModal';

export default LeadContractModal;
